import { Box, Button } from "@material-ui/core";

import { useAuth0, useStaffAuth0Active } from "../AuthProvider";
import LogOutLink from "../LogOutLink";
import Layout from "./Layout";

export default function SessionExpired(): JSX.Element {
  const auth0 = useAuth0();
  const staff = useStaffAuth0Active();

  const handleLogout = () => {
    let returnTo = `${window.location.origin}/login?loginImmediately=true&returnTo=${encodeURIComponent(
      document.location.pathname + document.location.search
    )}`;

    if (staff) {
      returnTo += "&staff=true";
    }

    auth0
      .logout({
        logoutParams: {
          returnTo
        }
      })
      .catch(console.error);
  };

  return (
    <Layout title="Session Expired">
      <p>Your log in session has expired. Please log in again.</p>
      <Box sx={{ margin: "24px 0" }}>
        <Button variant="contained" color="primary" onClick={handleLogout}>
          Log Back In
        </Button>
      </Box>
      <LogOutLink />
    </Layout>
  );
}
